import { Download, Search, Upload } from 'lucide-react'
import { Input } from '../../../../components/ui/input'
import { Button } from '@/view/components/ui/button'
import { useTableConsultsController } from './useTableConsultsController'
import { BasicTable } from '@/view/components/BasicTable'
import { Dialog } from '@/view/components/ui/dialog'
import { ConfirmationModal } from '@/view/components/ConfirmationModal'
import { Skeleton } from '@/view/components/ui/skeleton'
import { ImportDataModal } from '@/view/layouts/components/ImportDataModal'
import { DownloadAlert } from '@/view/components/DownloadAlert'

export const TableConsults = () => {
  const {
    table,
    isFetching,
    isLoading,
    getPageCount,
    getPageIndex,
    handleNextPage,
    handlePreviousPage,
    isDeleteConfirmationModalOpen,
    closeDeleteConfirmationModal,
    confirmDeleteQuery,
    isExporting,
    exportProgress,
    handleExportToExcel,
    isImportModalOpen,
    setIsImportModalOpen,
    handleSearchInputChange,
    searchValue,
  } = useTableConsultsController()

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div className="relative flex items-center">
          <Search size={20} className="z-2 absolute left-4 top-3" />
          <Input
            className="ml-1 w-40 rounded-3xl pl-10 md:w-60"
            placeholder="Pesquisar cliente"
            onChange={handleSearchInputChange}
            value={searchValue}
          />
        </div>

        <DownloadAlert isExporting={isExporting} progress={exportProgress} />

        <div className="flex gap-2">
          <Button
            variant="outline"
            className="w-[160px]"
            onClick={handleExportToExcel}
            disabled={isExporting}
          >
            <Download className="mr-2 h-5 w-5" />
            Exportar
          </Button>
          <Button
            onClick={() => setIsImportModalOpen(true)}
            className="w-[160px]"
          >
            <Upload className="mr-2 h-5 w-5" />
            Importar
          </Button>
        </div>
      </div>

      {(isFetching || isLoading) && (
        <div className="space-y-2">
          {[...Array(5)].map((_, i) => (
            <Skeleton key={i} className="h-16 w-full rounded-md" />
          ))}
        </div>
      )}

      {!isFetching && table && (
        <BasicTable
          type="only header"
          table={table}
          getPageCount={getPageCount}
          getPageIndex={getPageIndex}
          handleNextPage={handleNextPage}
          handlePreviousPage={handlePreviousPage}
        />
      )}

      <Dialog
        open={isDeleteConfirmationModalOpen}
        onOpenChange={closeDeleteConfirmationModal}
      >
        <ConfirmationModal
          title="Remover consulta"
          onConfirm={confirmDeleteQuery}
          Content={<>Tem certeza que deseja excluir?</>}
        />
      </Dialog>

      <ImportDataModal
        isOpen={isImportModalOpen}
        onOpenChange={setIsImportModalOpen}
      />
    </div>
  )
}
